var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCreativityPana = function SvgCreativityPana(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 280",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.18,92.08h65.75s-5.81-10.58-22.74-9c-16.16,1.47-17-5.21-25.2-6S334.92,82.49,332.18,92.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.32,265.9s-6.59,3.56,3,17.32,15.83,20.36,15.83,20.36,1.82,3.25-1,4.18-9.33.8-10.13,4.51c-.83,3.86,2.32,7,8.14,9.25s18.4,7.78,19.53,8.28,2.37,1.95.55,2.89-15.93,4.41-13.89,11,19.32,10.32,21.2,10.76,2.41,1.14,2.4,2.14-4.86,1.72-8.84,2.87-8.38,3.19-6.88,6.9,12.36,10.44,36.34,9.49l11.08-1.16,4.72-10.15c8.77-22.33,6-34.8,3-37.44s-6.38.86-8.77,4.24-4.67,7.72-5.62,7.4-1.43-1.05-1.23-3,2.37-19.46-3.19-23.56-13.48,8.08-15,9.49-2.45-.25-2.55-1.47-1.15-14.91-1.4-21.17-2.14-10.24-6.05-10.72-5.78,5.72-7.59,8.08-4.28-.43-4.28-.43-4.19-8.06-14-21.64S160.19,266,160.19,266",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.58,377.22c-7.19-10-19.66-28-30.45-43.39s-20.56-29.31-27.7-39.35c-3.57-5-6.45-9.06-8.46-11.87l-2.3-3.24-.59-.84c-.13-.19-.19-.3-.19-.3s.08.09.22.28l.62.82,2.35,3.2c2,2.77,5,6.81,8.55,11.81,7.19,10,17,23.9,27.78,39.29s23.23,33.41,30.37,43.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.12,312.83a4.23,4.23,0,0,1,.8.11c.51.09,1.24.24,2.15.44,1.81.39,4.29,1,7,1.72l7,1.87,2.12.56a3.31,3.31,0,0,1,.77.23,3.63,3.63,0,0,1-.8-.1c-.51-.09-1.24-.24-2.15-.45-1.8-.41-4.28-1-7-1.77l-7-1.82-2.12-.55A3,3,0,0,1,177.12,312.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.62,317c-.1,0,.93-5.2,2.29-11.56s2.55-11.51,2.64-11.49-.93,5.19-2.3,11.56S197.71,317,197.62,317Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.12,341.33a3.35,3.35,0,0,1,.35-.74l1.06-2c.89-1.66,2.12-4,3.37-6.56s2.33-5,3.08-6.69l.9-2.05a2.83,2.83,0,0,1,.37-.74,4.48,4.48,0,0,1-.24.79c-.18.5-.45,1.21-.8,2.09-.7,1.76-1.73,4.16-3,6.76s-2.53,4.88-3.47,6.52c-.48.81-.88,1.47-1.16,1.91A4.44,4.44,0,0,1,213.12,341.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.76,341.69a2.52,2.52,0,0,1,.75-.09l2.07-.12c1.74-.09,4.15-.18,6.81-.27s5.07-.14,6.82-.16h2.07a4.39,4.39,0,0,1,.76,0,2.82,2.82,0,0,1-.76.1l-2.06.12c-1.75.08-4.16.18-6.82.26s-5.07.14-6.82.16h-2.06A3.26,3.26,0,0,1,193.76,341.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.71,365a4.59,4.59,0,0,1,1-.11l2.65-.16c2.23-.12,5.32-.27,8.73-.41s6.5-.24,8.73-.3l2.65-.06a6.28,6.28,0,0,1,1,0,6.15,6.15,0,0,1-1,.11l-2.65.16c-2.23.12-5.32.27-8.73.41s-6.5.24-8.73.3l-2.65.06A6.09,6.09,0,0,1,204.71,365Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.81,363.8a6.17,6.17,0,0,1,.42-.95l1.26-2.55c1.06-2.15,2.5-5.12,4-8.45s2.8-6.37,3.72-8.59l1.09-2.62a6.91,6.91,0,0,1,.43-.94,5.18,5.18,0,0,1-.31,1c-.22.64-.55,1.55-1,2.66-.86,2.24-2.12,5.31-3.63,8.64s-3,6.3-4.11,8.42c-.56,1.06-1,1.92-1.36,2.5A6.8,6.8,0,0,1,228.81,363.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.8,216.22c-11.9-13.35-10.76-32.62-6.25-49.11.75-2.76,1.14-5.76,3-7.88s5.38-3.06,7.59-1.3c1.83,1.46,2.16,4.07,2.84,6.33a16.69,16.69,0,0,0,5,7.76c1.55,1.34,3.6,2.41,5.58,1.87,2.71-.76,3.77-4,4.41-6.77q1.77-7.73,3.56-15.46a26.84,26.84,0,0,1,2.77-8c1.48-2.42,4-4.4,6.76-4.51s5.69,2.17,5.6,5a26.31,26.31,0,0,1-.73,3.46,3,3,0,0,0,1.05,3.13c1,.59,2.31.07,3.33-.55,3.51-2.11,6.3-5.24,8.95-8.39s5.27-6.38,8.58-8.81,7.45-4,11.46-3.28,7.64,4.16,7.72,8.27-3.12,7.55-6.34,10.11A63.37,63.37,0,0,1,381,157.28a5.18,5.18,0,0,0-2.69,1.8c-1,1.7.27,3.94,1.94,5,1.9,1.17,4.18,1.49,6.28,2.25s4.2,2.27,4.53,4.49c.46,3.09-2.6,5.49-5.38,6.88A54.43,54.43,0,0,1,367.94,183c-2.21.26-4.5.41-6.48,1.44s-3.55,3.29-3,5.47,2.92,3.41,5.14,3.51,4.4-.59,6.61-.87c4.13-.54,9,.88,10.62,4.74a9,9,0,0,1-.9,8,20.64,20.64,0,0,1-5.8,5.83,54.6,54.6,0,0,1-26.44,10.56c-9.52,1-17.88-.14-25.87-5.41",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.22,217.82c2.16-6.44-.1-3.21,4.35-11A254.3,254.3,0,0,1,344.7,182.5q2.3-3.12,4.55-6.15c1.5-2,3-4,4.56-5.89a128.52,128.52,0,0,1,9.67-10.2c3.23-3.1,6.41-5.92,9.41-8.54s5.84-5,8.52-7.05a101.56,101.56,0,0,1,13.37-8.77c1.65-.91,3-1.57,3.85-2l1-.49.35-.15a1.93,1.93,0,0,1-.33.2l-1,.54c-.88.47-2.17,1.16-3.8,2.09A105.85,105.85,0,0,0,381.63,145c-2.66,2.07-5.48,4.46-8.46,7.08s-6.14,5.46-9.36,8.56a131.24,131.24,0,0,0-9.61,10.18c-1.56,1.86-3,3.85-4.53,5.87l-4.55,6.15A261.69,261.69,0,0,0,329,207.05c-4.46,7.77-2.22,4.49-4.42,10.89",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,170.48a6.27,6.27,0,0,1,0-1.24c0-.8.13-2,.26-3.37.26-2.85.76-6.76,1.32-11.07s1-8.22,1.21-11.06c.11-1.42.19-2.56.24-3.36a5.41,5.41,0,0,1,.13-1.23,6.09,6.09,0,0,1,.07,1.24c0,.79,0,2-.07,3.37-.12,2.86-.5,6.79-1.07,11.11s-1.07,8.1-1.46,11c-.17,1.33-.31,2.45-.42,3.35A5.77,5.77,0,0,1,354,170.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,172.25a7.07,7.07,0,0,1-1.45-.16c-.93-.14-2.28-.34-3.95-.54-3.33-.42-8-.83-13.08-1.07s-9.77-.24-13.14-.15c-1.68,0-3,.1-4,.14a8.78,8.78,0,0,1-1.47,0,7.94,7.94,0,0,1,1.46-.22c.94-.1,2.3-.22,4-.3,3.37-.19,8-.24,13.18,0a131,131,0,0,1,13.11,1.23c1.66.25,3,.51,3.93.7A7.59,7.59,0,0,1,391,172.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.16,206.26a1.56,1.56,0,0,1-.14-.49c-.08-.39-.18-.86-.31-1.43-.25-1.24-.58-3-.95-5.28-.75-4.47-1.59-10.68-2.43-17.55s-1.62-13.08-2.27-17.56c-.32-2.18-.59-4-.79-5.3-.08-.58-.15-1.06-.21-1.45a2.77,2.77,0,0,1,0-.51,1.88,1.88,0,0,1,.15.49l.3,1.43c.26,1.24.58,3,.95,5.28.75,4.47,1.59,10.68,2.43,17.55s1.62,13.08,2.27,17.56c.33,2.18.59,4,.79,5.31.09.57.15,1.05.21,1.44A2,2,0,0,1,329.16,206.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.93,202.23a1.68,1.68,0,0,1-.51.08l-1.48.14-5.44.44c-4.59.37-10.93,1-17.93,1.62s-13.36,1.19-18,1.47c-2.3.14-4.16.23-5.45.27l-1.48,0a1.76,1.76,0,0,1-.52,0,2.05,2.05,0,0,1,.51-.08l1.48-.14,5.44-.44c4.59-.37,10.93-1,17.93-1.62s13.35-1.19,18-1.46c2.31-.14,4.17-.24,5.46-.28l1.48,0A2.09,2.09,0,0,1,379.93,202.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.31,304a2.15,2.15,0,0,1-.16.47l-.55,1.33c-.51,1.2-1.23,2.89-2.13,5l-7.71,17.83-.05.1-.11,0-24.22,4-8.12,1.33-.37.06.09-.36c2-7.79,3.79-15,5.34-21.05l.11.23-14.23-6.36-3.93-1.79-1-.48a1.79,1.79,0,0,1-.34-.19l.36.13,1.05.43,4,1.69,14.3,6.2.16.07,0,.16c-1.52,6.1-3.31,13.28-5.25,21.08l-.28-.3,8.12-1.34,24.23-3.94-.17.13,7.87-17.75c.95-2.12,1.71-3.8,2.25-5l.6-1.31A3.31,3.31,0,0,1,419.31,304Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.1 331.25 378.43 332.99 379.49 334.53 377.63 334.44 376.5 335.92 376.01 334.12 374.25 333.5 375.81 332.48 375.86 330.62 377.31 331.79 379.1 331.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.47 303 362.14 303.87 362.66 304.63 361.74 304.58 361.18 305.32 360.93 304.43 360.06 304.12 360.83 303.61 360.86 302.68 361.58 303.26 362.47 303",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.44 327.56 409.11 328.43 409.63 329.19 408.71 329.15 408.15 329.89 407.9 328.99 407.03 328.69 407.8 328.18 407.82 327.25 408.55 327.83 409.44 327.56",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.33 311.97 382 312.83 382.53 313.6 381.6 313.55 381.04 314.29 380.8 313.39 379.92 313.09 380.7 312.58 380.72 311.65 381.44 312.23 382.33 311.97",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.44 303.13 420.11 304 420.64 304.76 419.71 304.72 419.15 305.46 418.91 304.56 418.03 304.25 418.81 303.75 418.83 302.82 419.55 303.4 420.44 303.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.34,375.91H169.7s-4.63-8.43-18.11-7.2c-12.87,1.17-13.52-4.15-20.07-4.8S119.53,368.27,117.34,375.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.74,169.79h52.35s-4.63-8.42-18.11-7.2c-12.86,1.18-13.52-4.14-20.06-4.79S129.92,162.16,127.74,169.79Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.62,206.2h43s-3.8-6.92-14.87-5.92c-10.58,1-11.12-3.4-16.49-3.94S395.41,199.93,393.62,206.2Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.73,291.09c2.14-16.11-9.19-29.41-23.35-37.4S253.79,243,238.15,238.58c-14.75-4.19-29.42-10.31-40.34-21.07s-17.48-26.93-13.56-41.75c1-3.72,2.75-7.46,5.95-9.61s8.07-2.09,10.46.93c5.08,6.44-4.82,18,1.38,23.34,1.42,1.24,3.38,1.69,4.85,2.86,3.91,3.13,2.65,9.2,3.2,14.18,1.09,9.85,10.33,16.69,19.4,20.68,12.15,5.34,25.31,7.85,38.19,11s25.89,7.16,36.62,15,20.06,20,20,33.29c0,3.71-.49,8.27-2.82,11.15s-5.29,3.49-8.65,1.91-5.7-4-5.08-9.38",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.73,291.09c2.14-16.11-9.19-29.41-23.35-37.4S253.79,243,238.15,238.58c-14.75-4.19-29.42-10.31-40.34-21.07s-17.48-26.93-13.56-41.75c1-3.72,2.75-7.46,5.95-9.61s8.07-2.09,10.46.93c5.08,6.44-4.82,18,1.38,23.34,1.42,1.24,3.38,1.69,4.85,2.86,3.91,3.13,2.65,9.2,3.2,14.18,1.09,9.85,10.33,16.69,19.4,20.68,12.15,5.34,25.31,7.85,38.19,11s25.89,7.16,36.62,15,20.06,20,20,33.29c0,3.71-.49,8.27-2.82,11.15s-5.29,3.49-8.65,1.91-5.7-4-5.08-9.38",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M239.23,163c-.51-6,3.94-11.17,9-13.95s10.86-3.92,16.07-6.39c12.95-6.14,21.18-20.59,21.79-35.4s-5.82-29.63-15.86-40.51c-4.09-4.42-9.11-9.06-9.17-15.09-.06-6.3,6-11.26,12.14-11.18s11.72,4.17,15.37,9.3S294.23,61,296.2,67c-1.4-2.52,1.47-5.63,4.25-5.36s5,2.58,6.67,4.88a52.1,52.1,0,0,1,10,34.85,49.1,49.1,0,0,1-15.5,31.94c-9.87,9-22.92,13.21-35.58,17.21l-26.41,8.33",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.23,163c-.51-6,3.94-11.17,9-13.95s10.86-3.92,16.07-6.39c12.95-6.14,21.18-20.59,21.79-35.4s-5.82-29.63-15.86-40.51c-4.09-4.42-9.11-9.06-9.17-15.09-.06-6.3,6-11.26,12.14-11.18s11.72,4.17,15.37,9.3S294.23,61,296.2,67c-1.4-2.52,1.47-5.63,4.25-5.36s5,2.58,6.67,4.88a52.1,52.1,0,0,1,10,34.85,49.1,49.1,0,0,1-15.5,31.94c-9.87,9-22.92,13.21-35.58,17.21l-26.41,8.33",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M231.88,37.52a5.62,5.62,0,1,0,.92-.29",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.88,37.52a5.62,5.62,0,1,0,.92-.29",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.45,422.84c-3.24-6.71-.41-15.08,4.75-20.46s12.2-8.45,19-11.45c15.06-6.64,31-14.54,38.65-29.1,2.58-4.91,4.05-10.31,5.5-15.67,2.81-10.36,5.45-22.13-.2-31.26-1.63-2.63-4.07-5-7.11-5.5-3.47-.62-7,1.29-9.16,4.08a20.23,20.23,0,0,0-3.49,9.83c-.84,6.63-.14,13.38-.84,20S308.44,357,303,360.78c-6.67,4.65-16.18,3.61-22.65,8.52-5.23,4-7.22,10.84-11.3,16-3.44,4.31-8.25,7.25-12.65,10.57s-8.66,7.36-10.16,12.67a15,15,0,0,0,20.89,17.63",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.45,422.84c-3.24-6.71-.41-15.08,4.75-20.46s12.2-8.45,19-11.45c15.06-6.64,31-14.54,38.65-29.1,2.58-4.91,4.05-10.31,5.5-15.67,2.81-10.36,5.45-22.13-.2-31.26-1.63-2.63-4.07-5-7.11-5.5-3.47-.62-7,1.29-9.16,4.08a20.23,20.23,0,0,0-3.49,9.83c-.84,6.63-.14,13.38-.84,20S308.44,357,303,360.78c-6.67,4.65-16.18,3.61-22.65,8.52-5.23,4-7.22,10.84-11.3,16-3.44,4.31-8.25,7.25-12.65,10.57s-8.66,7.36-10.16,12.67a15,15,0,0,0,20.89,17.63",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164.33,83.86a20.85,20.85,0,0,1,.6-33.91c3.08-2.11,6.72-3.41,9.46-6,2.43-2.26,4-5.39,6.73-7.29A9.8,9.8,0,0,1,196,48c-1.25,3.51-4.4,6.08-5.72,9.56-1.42,3.76-.5,8-1,11.94a16.49,16.49,0,0,1-22.08,13.28",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.33,83.86a20.85,20.85,0,0,1,.6-33.91c3.08-2.11,6.72-3.41,9.46-6,2.43-2.26,4-5.39,6.73-7.29A9.8,9.8,0,0,1,196,48c-1.25,3.51-4.4,6.08-5.72,9.56-1.42,3.76-.5,8-1,11.94a16.49,16.49,0,0,1-22.08,13.28",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164.71,62.42H177a0,0,0,0,1,0,0V87.75a5.41,5.41,0,0,1-5.41,5.41h-1.46a5.41,5.41,0,0,1-5.41-5.41V62.42A0,0,0,0,1,164.71,62.42Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.71 62.42 170.85 51.15 177 62.42 164.71 62.42",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.42,55.61s1.87,2.81,4.87,0l-2.43-4.46Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.17,86.52a39,39,0,0,1-6.25.25,38.85,38.85,0,0,1-6.24-.25,38.85,38.85,0,0,1,6.24-.25A39,39,0,0,1,177.17,86.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,84.63a37.41,37.41,0,0,1-6.12.25,37.41,37.41,0,0,1-6.12-.25,39.6,39.6,0,0,1,6.12-.24A39.6,39.6,0,0,1,177,84.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.32,62.6c.13,0,.25,4.9.25,10.95s-.12,11-.25,11-.25-4.91-.25-11S168.18,62.6,168.32,62.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.29,62.6c.14,0,.25,4.9.25,10.95s-.11,11-.25,11-.25-4.91-.25-11S173.15,62.6,173.29,62.6Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notebook--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "271.49 408.72 327.32 411.11 328.67 414.36 292.07 473.76 226.01 471.83 271.49 408.72",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.51 466.04 289.96 469.84 324.68 415.97 300.3 417.95 238.61 439.67 223.51 466.04",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.17,462.05l61,1c-2.53-7.81,3.44-18.8,11.65-22.5,5.44-2.45,15.67-5.63,20.95-8.34,10-5.15,19.1-14.89,18.31-23.26L301,408.12l-32-1.24c-2.68,7.94-8.4,13.13-17.1,16.26-7.78,2.8-16.64,2.79-24.24,6-12.22,5.12-18.09,21.71-13.54,32.94",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.17,462.05s-.06-.13-.15-.4l-.42-1.17a14.21,14.21,0,0,1-.52-2,20.31,20.31,0,0,1-.42-2.78,28.56,28.56,0,0,1,.48-7.76,29,29,0,0,1,3.92-9.68,23.55,23.55,0,0,1,1.75-2.46c.33-.39.65-.82,1-1.2l1.13-1.15a10.55,10.55,0,0,1,1.22-1.09c.43-.35.85-.72,1.31-1.05a22.44,22.44,0,0,1,3-1.78c4.23-2.13,9.28-3,14.54-4,2.64-.48,5.36-1,8.08-1.73a37.79,37.79,0,0,0,8.05-3.24,26.58,26.58,0,0,0,3.75-2.46,22.52,22.52,0,0,0,3.33-3.15,24,24,0,0,0,4.64-8.18l.06-.17h.17l26.65,1c9.25.36,18.82.61,28.62.94l1.78.06h.22l0,.22a13.62,13.62,0,0,1-.8,5.64,21.44,21.44,0,0,1-1.12,2.6,25.14,25.14,0,0,1-1.46,2.4,37.13,37.13,0,0,1-7.56,8,44.85,44.85,0,0,1-9.13,5.63c-3.22,1.45-6.48,2.63-9.67,3.81s-6.35,2.3-9.34,3.6a18.66,18.66,0,0,0-4.11,2.5c-.65.46-1.19,1.05-1.78,1.56s-1.1,1.13-1.57,1.76a22.66,22.66,0,0,0-4.27,8,14.9,14.9,0,0,0-.15,8.54l.09.27h-.28l-44.39-.78-12.31-.25-3.22-.09-1.11,0s.38,0,1.11,0l3.23,0,12.31.14,44.38.62-.19.26a15.2,15.2,0,0,1,.13-8.78,22.85,22.85,0,0,1,4.33-8.18c.47-.64,1.06-1.19,1.59-1.79s1.16-1.13,1.82-1.61a18.48,18.48,0,0,1,4.2-2.55c3-1.32,6.18-2.45,9.37-3.63s6.44-2.37,9.63-3.81a43.86,43.86,0,0,0,9-5.58,36.53,36.53,0,0,0,7.46-7.88A26.92,26.92,0,0,0,324,416.9a21,21,0,0,0,1.09-2.53,13.21,13.21,0,0,0,.78-5.43l.24.22-1.79-.05c-9.8-.33-19.37-.59-28.61-1l-26.66-1,.23-.16a24.68,24.68,0,0,1-4.74,8.33,22.8,22.8,0,0,1-3.4,3.2,26,26,0,0,1-3.82,2.49,37.53,37.53,0,0,1-8.14,3.26c-2.75.75-5.48,1.25-8.12,1.72-5.26.94-10.29,1.82-14.46,3.9a21.76,21.76,0,0,0-2.93,1.74c-.46.32-.87.69-1.3,1a10.37,10.37,0,0,0-1.21,1.08L220,434.82c-.36.38-.67.8-1,1.19a22.1,22.1,0,0,0-1.75,2.42,28.6,28.6,0,0,0-3.93,9.58,28.07,28.07,0,0,0-.55,7.7,19.33,19.33,0,0,0,.38,2.77,14.24,14.24,0,0,0,.48,2c.17.52.29.91.38,1.19S214.17,462.05,214.17,462.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.19,407.87s.08-.39.14-1.09a6.15,6.15,0,0,0-.48-2.88,5.91,5.91,0,0,0-2.88-3.1,6.6,6.6,0,0,0-8.86,3.4,7.39,7.39,0,0,0-.59,4.25,7.28,7.28,0,0,0,1,2.74c.38.6.66.88.63.91a2.88,2.88,0,0,1-.78-.8,6.69,6.69,0,0,1-1.23-2.79,7.51,7.51,0,0,1,.51-4.5,7,7,0,0,1,9.48-3.62,6.16,6.16,0,0,1,3,3.38,5.85,5.85,0,0,1,.34,3,4.29,4.29,0,0,1-.2.81C286.25,407.79,286.21,407.87,286.19,407.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.76,407.87c-.05,0,.08-.39.14-1.09a6.28,6.28,0,0,0-.48-2.88,5.94,5.94,0,0,0-2.89-3.1,6.61,6.61,0,0,0-8.86,3.4,7.38,7.38,0,0,0-.58,4.25,7.12,7.12,0,0,0,1,2.74c.38.6.66.88.63.91a2.67,2.67,0,0,1-.79-.8,6.82,6.82,0,0,1-1.23-2.79,7.6,7.6,0,0,1,.52-4.5,7,7,0,0,1,9.47-3.62,6.16,6.16,0,0,1,3,3.38,6,6,0,0,1,.35,3,3.55,3.55,0,0,1-.21.81A.71.71,0,0,1,295.76,407.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,408.37s.06-.4.08-1.1a6.23,6.23,0,0,0-.64-2.85,5.92,5.92,0,0,0-3.06-2.92,6.66,6.66,0,0,0-5.14.1,6.74,6.74,0,0,0-3.51,3.78,7.43,7.43,0,0,0-.35,4.28,7.17,7.17,0,0,0,1.2,2.68c.41.57.71.84.68.87a2.68,2.68,0,0,1-.83-.75,6.76,6.76,0,0,1-1.39-2.72,7.59,7.59,0,0,1,.26-4.52,7,7,0,0,1,9.26-4.15,6.16,6.16,0,0,1,3.19,3.2,5.86,5.86,0,0,1,.52,3,3.57,3.57,0,0,1-.16.82C303.08,408.28,303,408.37,303,408.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.81,408.81s0-.4,0-1.1a6.12,6.12,0,0,0-.79-2.81,5.9,5.9,0,0,0-3.21-2.76,6.6,6.6,0,0,0-8.43,4.34,7.36,7.36,0,0,0-.12,4.29,7.27,7.27,0,0,0,1.34,2.62c.44.54.75.79.72.83a2.8,2.8,0,0,1-.87-.71,6.81,6.81,0,0,1-1.53-2.64,7.59,7.59,0,0,1,0-4.53,7.08,7.08,0,0,1,3.51-4.26,7,7,0,0,1,5.52-.37,6.2,6.2,0,0,1,3.36,3,5.9,5.9,0,0,1,.67,3,4.16,4.16,0,0,1-.11.82C310.86,408.72,310.83,408.81,310.81,408.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.61,408.63s0-.4,0-1.1a6.13,6.13,0,0,0-.87-2.79,5.93,5.93,0,0,0-3.28-2.67,6.59,6.59,0,0,0-8.31,4.58,7.31,7.31,0,0,0,1.41,6.87c.46.53.78.77.75.8a2.55,2.55,0,0,1-.89-.67,6.92,6.92,0,0,1-1.6-2.6,7.57,7.57,0,0,1-.11-4.53,7.11,7.11,0,0,1,3.39-4.36,7,7,0,0,1,5.5-.52,6.22,6.22,0,0,1,3.45,2.92,5.93,5.93,0,0,1,.75,3,3.92,3.92,0,0,1-.09.83C318.66,408.53,318.63,408.63,318.61,408.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.19,409.5s0-.4,0-1.1a6.11,6.11,0,0,0-.76-2.82,5.93,5.93,0,0,0-3.17-2.79,6.59,6.59,0,0,0-8.48,4.24,7.35,7.35,0,0,0,1.13,6.92c.44.55.74.8.72.84a2.73,2.73,0,0,1-.86-.72,6.67,6.67,0,0,1-1.5-2.66,7.55,7.55,0,0,1,.07-4.53,7.08,7.08,0,0,1,3.56-4.22,7,7,0,0,1,5.52-.3,6.13,6.13,0,0,1,3.32,3.06,5.87,5.87,0,0,1,.64,3,4,4,0,0,1-.12.82C325.24,409.41,325.21,409.51,325.19,409.5Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--air-balloon--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354,204.65a54.58,54.58,0,0,0-8.27.38,34.39,34.39,0,0,0-30,34.29,61.3,61.3,0,0,0,2.13,16.35c4.81,17.06,6.29,32.09,5.74,39.42l16.1,8.65s7.45-10.71,14.65-15.33,31.16-17,40.65-29.65c6.11-8.18,7.29-25-7.29-39.66A49.43,49.43,0,0,0,354,204.65Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.9 313.71 330.44 321.57 320.98 333.59 311.28 329.19 315.9 313.71",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.61,314.2c-.13-.05,1.31-4.37,3.22-9.64s3.56-9.52,3.69-9.47-1.31,4.36-3.22,9.64S316.74,314.24,316.61,314.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.53,321c-.12-.07,2.16-4.15,5.08-9.11S340,303,340.13,303s-2.16,4.15-5.09,9.11S329.64,321.05,329.53,321Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M358.8,205.11c-.65,0-8.65,9.4-12.19,15.74-11.91,21.33-12.45,42.08-15.75,66.28-.47,3.46-2.19,10.91-2.16,10.74,1.76,1.38,7.68,4.13,7.68,4.13s5.59-6.74,7.81-10.13c8.88-13.57,18.53-24.16,26.14-38.49s14.93-27,7.89-41.66C378.22,211.72,366,204.7,358.8,205.11Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M395,260.9a2.68,2.68,0,0,1-.21-.46c-.13-.3-.29-.77-.56-1.35a24.17,24.17,0,0,0-2.81-4.73,24.6,24.6,0,0,0-6.17-5.76,23.62,23.62,0,0,0-10.13-3.75H375l-.06-.08a57.13,57.13,0,0,0-6.49-7.46,32.74,32.74,0,0,0-8.87-6.1,22.79,22.79,0,0,0-10.49-2,17.31,17.31,0,0,0-9.17,3.06l-.15.1-.13-.12a18,18,0,0,0-9.8-4.35,17.67,17.67,0,0,0-8.33,1.06,18.7,18.7,0,0,0-4.78,2.69c-.5.4-.88.72-1.12.94a2.52,2.52,0,0,1-.39.32,4.37,4.37,0,0,1,.34-.37c.23-.24.59-.58,1.08-1a17.55,17.55,0,0,1,4.78-2.83,17.77,17.77,0,0,1,8.47-1.18,18.29,18.29,0,0,1,10.05,4.39l-.28,0a17.71,17.71,0,0,1,9.41-3.17,23.32,23.32,0,0,1,10.71,2,33,33,0,0,1,9,6.21,55.8,55.8,0,0,1,6.52,7.55l-.15-.09a23.63,23.63,0,0,1,10.28,3.88,24.69,24.69,0,0,1,6.19,5.91,22.74,22.74,0,0,1,2.72,4.84c.25.59.39,1.07.5,1.38A3.87,3.87,0,0,1,395,260.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.06,282.15a10.38,10.38,0,0,0-1.39-3.49,9.5,9.5,0,0,0-3.09-3,8.65,8.65,0,0,0-5.33-1.26l-.2,0,0-.2a14.23,14.23,0,0,0-8.61-10.86,14.36,14.36,0,0,0-6.25-.95A14.09,14.09,0,0,0,334.6,264l-.15.08-.12-.13a10.2,10.2,0,0,0-5.59-3,11.27,11.27,0,0,0-5,.16,11.73,11.73,0,0,0-4,2s.06-.09.21-.22.37-.34.68-.57a10.09,10.09,0,0,1,3-1.45,11.3,11.3,0,0,1,5.15-.26,10.44,10.44,0,0,1,5.85,3.09l-.27-.05a14.55,14.55,0,0,1,5.74-1.66,14.74,14.74,0,0,1,6.46,1,14.2,14.2,0,0,1,6.17,4.82,14.37,14.37,0,0,1,2.68,6.43l-.23-.18a9,9,0,0,1,5.55,1.39,9.64,9.64,0,0,1,3.12,3.13,8.38,8.38,0,0,1,1.06,2.64,6.65,6.65,0,0,1,.11.74A1.17,1.17,0,0,1,365.06,282.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.63,325.36s-.16-.2-.53-.36a2.63,2.63,0,0,0-1.7.06,5.14,5.14,0,0,1-1.29.23,2,2,0,0,1-1.44-.63c-.77-.81-1.06-2-1.79-2.77a1.68,1.68,0,0,0-1.34-.57,8.37,8.37,0,0,0-1.52.31,3.41,3.41,0,0,1-1.52.08,2.91,2.91,0,0,1-2.15-2.23,1.16,1.16,0,0,1,0-.68s0,.24.17.64a2.94,2.94,0,0,0,1,1.39,2.3,2.3,0,0,0,1.05.47,3,3,0,0,0,1.33-.12,8,8,0,0,1,1.61-.34,2.14,2.14,0,0,1,1.72.71c.85,1,1.11,2.1,1.76,2.79a1.63,1.63,0,0,0,1.12.54,4.62,4.62,0,0,0,1.19-.17,2.62,2.62,0,0,1,1.87.12C327.59,325.07,327.65,325.36,327.63,325.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.3,323a61.46,61.46,0,0,1-7.09-3.5,64.91,64.91,0,0,1-6.87-3.94,64.09,64.09,0,0,1,7.1,3.5A65.34,65.34,0,0,1,329.3,323Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.41,326.69s-.2.1-.55.26c-.18.08-.38.2-.66.32a2.46,2.46,0,0,1-1,.13,4.16,4.16,0,0,1-2.4-.93,3.29,3.29,0,0,1-.91-1.25,4.55,4.55,0,0,0-.71-1.31,3.37,3.37,0,0,0-2.63-.76,6.06,6.06,0,0,1-2.53-.24,2.36,2.36,0,0,1-1.28-1.17c-.16-.39-.1-.64-.08-.63s.06.22.26.54a2.28,2.28,0,0,0,1.23.93,6,6,0,0,0,2.38.11,3.74,3.74,0,0,1,3,.88,5,5,0,0,1,.78,1.45,3,3,0,0,0,.77,1.11,4.06,4.06,0,0,0,2.13.92,3,3,0,0,0,1.56-.28C326.18,326.66,326.41,326.66,326.41,326.69Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.62,233.3l25.15-3.73-12-17-6.44.38a11.49,11.49,0,0,0-9.89,6.92h0a11.53,11.53,0,0,0-.73,6.74Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.62,233.3l25.15-3.73-12-17-6.44.38a11.49,11.49,0,0,0-9.89,6.92h0a11.53,11.53,0,0,0-.73,6.74Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.64,261.16c.26.72.54,1.57.83,2.59a8.2,8.2,0,0,1,.27,2.7,12.52,12.52,0,0,1-.57,3.32c-.41,1,.55,1.92,1.36,1.44s2-3.08,2-6.42,3.34.66,4.61,2.1,5.41,5.71,6.16,5.67c1.1-.06,1.24-1.25-.06-2.66s-4.91-5.9-4.12-6.54,7.15,6.79,7.15,6.79,1.1,1.81,2,1.11c1.7-1.27-5.65-8.66-6.37-9.34-.49-.48.34-1.2.85-.66s6.18,7.55,7.92,6.27c1.33-1-6-6.13-6.36-8.23s5.16,4.47,6.39,3.49c.47-.37.76-.71-3-4-1.8-1.62-8.66-6.42-8.66-6.42l-20.64-59.09-15.94,9.13Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.77,149.4l-23.06-27.52h0a16.06,16.06,0,0,0-1.13-2.75,8.65,8.65,0,0,0-5.44-4.54c-1.46-.32-3.14-.16-4.29-1.12-.51-.43-.85-1-1.39-1.44s-1.43-.48-1.78.09a1.57,1.57,0,0,0,.1,1.38,12.83,12.83,0,0,0,4,5.16c-2.16.66-5.25,1.66-5.25,1.66s-4.87-5.29-7.37-5.28,2,4.73,2,4.73-4-3.7-5.24-2.66,1.94,3.79,1.94,3.79a5.3,5.3,0,0,0-3.25-.91c-1.13.19-2.1,1.52-1.49,2.49a2.6,2.6,0,0,0,1,.81l6.14,3.42a7.43,7.43,0,0,0,3.28,1.2c3.12.1,5.49-1.83,8.6-1.75,0,0,17.39,36.61,19.15,38.5s40,4.46,40,4.46l22.11-19.05Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.05,348.83l23.55,10.25L282,388.45c-2.74-1.37-1.84-19-1.84-19l-15.36-5.95Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.77,359.84a1.31,1.31,0,0,1,1.73-.25,1.26,1.26,0,0,1,.25,1.71,1.37,1.37,0,0,1-1.82.25,1.3,1.3,0,0,1-.07-1.81",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M294.6,359.08l-2.42-.94L281,386.65s0,1.56,1,1.8Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.79,369.88c.15.05.52-.64,1.29-1.14s1.52-.63,1.52-.78-.92-.3-1.83.33S279.65,369.85,279.79,369.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.74,373.5c.13.1.64-.42,1.46-.65s1.51-.09,1.57-.23-.72-.59-1.73-.29S279.61,373.44,279.74,373.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.68,376.84c.09-.12-.55-.63-1.49-.6s-1.54.57-1.45.68.69-.12,1.47-.13S282.6,377,282.68,376.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.44,368.13c.16,0,.24-.75.65-1.53s.93-1.31.84-1.44-.87.26-1.33,1.19S276.3,368.15,276.44,368.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.26,365.93c.06,0,.39-.5.62-1.47a6.86,6.86,0,0,0,.19-1.74,7.63,7.63,0,0,0-.08-1,1.94,1.94,0,0,0-.16-.59.67.67,0,0,0-.73-.39.83.83,0,0,0-.6.48,2.18,2.18,0,0,0-.16.59,5.61,5.61,0,0,0,.23,2.79c.33.95.77,1.41.82,1.37s-.23-.57-.46-1.48a6.64,6.64,0,0,1-.17-1.63,6.52,6.52,0,0,1,.1-1c.05-.34.16-.61.34-.63s.08,0,.15.1a2,2,0,0,1,.11.44,8.23,8.23,0,0,1,.11,1,8.54,8.54,0,0,1-.07,1.65A11.28,11.28,0,0,0,273.26,365.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.54,365.84s-.34-.55-1.25-1a5.1,5.1,0,0,0-1.7-.49,4.58,4.58,0,0,0-1,0,1.35,1.35,0,0,0-1.15.62.76.76,0,0,0,.15.79,2.28,2.28,0,0,0,.48.38,3.59,3.59,0,0,0,1,.43,3.7,3.7,0,0,0,1.78,0c1-.25,1.44-.77,1.4-.8a13.5,13.5,0,0,1-1.47.42,3.66,3.66,0,0,1-1.58-.12,3.39,3.39,0,0,1-.84-.4c-.29-.18-.49-.4-.41-.5a.89.89,0,0,1,.7-.31,5.17,5.17,0,0,1,1,0,5.77,5.77,0,0,1,1.59.34C273,365.52,273.49,365.9,273.54,365.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.91,389.17l9.74,20.41L265.7,428a2.31,2.31,0,0,0,2.82,1.87h0a2.29,2.29,0,0,0,1.61-1.38c1.79-4.43,8.3-20.78,7.5-22.23-.92-1.68-8.85-22.21-8.85-22.21Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.52,429.82l8.48-25,.4.87a3.49,3.49,0,0,1,.17,2.4c-.62,2.13-2.45,8-7.38,20.32a2.3,2.3,0,0,1-1.67,1.41Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.78,400.07a1.39,1.39,0,0,0,.4,1.82,1.35,1.35,0,0,0,1.82-.38,1.49,1.49,0,0,0-.44-1.93,1.39,1.39,0,0,0-1.84.61",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M269.18,418.69a5,5,0,0,0-5.11-.18s.15-.32.6-.6a3.58,3.58,0,0,1,2-.51,3.63,3.63,0,0,1,1.95.64C269.06,418.36,269.22,418.65,269.18,418.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,422.11a17.25,17.25,0,0,0-2.22-.06,19.15,19.15,0,0,0-2.13.64c-.11-.08.69-1,2.06-1.14A2.56,2.56,0,0,1,269,422.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.32,413.92a22.54,22.54,0,0,0-3.42-.33,21.25,21.25,0,0,0-3.38.66,6.31,6.31,0,0,1,6.8-.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.88,407.47c0,.15-1.35.18-2.86.8s-2.52,1.49-2.62,1.38a4.5,4.5,0,0,1,2.44-1.85A4.45,4.45,0,0,1,267.88,407.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.17,401.4a11.51,11.51,0,0,0-3,.76,11.08,11.08,0,0,0-2.42,1.91c-.05,0,.05-.39.41-.87a4.88,4.88,0,0,1,1.8-1.49,4.93,4.93,0,0,1,2.27-.52C264.83,401.21,265.18,401.35,265.17,401.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.69,401a2.33,2.33,0,0,1-.38-.77,6.05,6.05,0,0,1-.29-2.32,2.63,2.63,0,0,1,.51-1.61.93.93,0,0,1,1-.25,1.56,1.56,0,0,1,.75.79,3.27,3.27,0,0,1-1.38,3.94,3.81,3.81,0,0,1-4.22-.28,1.31,1.31,0,0,1-.5-1,.91.91,0,0,1,.67-.83,3.29,3.29,0,0,1,1.68.1,6.46,6.46,0,0,1,2.13,1c.45.31.65.54.63.57a10,10,0,0,0-2.84-1.2,2.93,2.93,0,0,0-1.47-.05.49.49,0,0,0-.37.45.94.94,0,0,0,.37.62,3.39,3.39,0,0,0,3.66.21A2.84,2.84,0,0,0,262.9,397a1.05,1.05,0,0,0-.5-.57.49.49,0,0,0-.57.12,2.32,2.32,0,0,0-.46,1.36A8.87,8.87,0,0,0,261.69,401Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.73,351.32l-26.71-18,8.84-86.79-25.3-14.77-23.13-5.36s-9.66,20.1-14,33c-9.14,27.37-15.55,37.18-14.08,57,.46,6.28,23.64,22,38.28,30.71a47.57,47.57,0,0,0,.78,5.19c5,22.62,20.28,52.7,20.28,52.7l23.2-10.79-7.48-25.65,7.8,4.55Zm-57.41-56,3.12-13.91c-.66,8.85-1.26,18.08-1.69,26.93A27.64,27.64,0,0,1,228.32,295.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.73,405a2.21,2.21,0,0,1-.18-.37l-.49-1.09-1.79-4.23c-1.54-3.69-3.75-9-6.4-15.65s-5.79-14.53-9-23.43c-.79-2.23-1.56-4.52-2.29-6.89-.32-1.2-.73-2.38-.94-3.65-.06-.31-.13-.63-.18-.94l-.11-.95-.21-1.9q-.42-3.84-.67-7.82c-.08-1.32-.15-2.66-.21-4s-.1-2.71,0-4.08c.4-10.9,1.31-21.24,2.07-30.65s1.49-17.87,2.09-25,1-12.87,1.2-16.86c.13-2,.2-3.54.24-4.58l.07-1.2a1.51,1.51,0,0,1,0-.4,2.38,2.38,0,0,1,0,.4c0,.3,0,.69,0,1.2,0,1.05-.05,2.6-.14,4.59-.17,4-.52,9.76-1.05,16.88s-1.24,15.59-2,25-1.63,19.75-2,30.62c-.08,1.36,0,2.7,0,4.05s.12,2.67.21,4q.24,4,.65,7.79l.21,1.91.11.94c.05.31.12.61.18.92.2,1.22.6,2.41.92,3.6.71,2.35,1.48,4.64,2.26,6.87,3.14,8.89,6.25,16.8,8.85,23.45s4.77,12,6.26,15.7c.73,1.84,1.31,3.27,1.71,4.27.18.47.33.84.43,1.11S250.73,405,250.73,405Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.87,248.37s-.23-.14-.6-.49a6.31,6.31,0,0,1-1.13-1.82,19.44,19.44,0,0,1-1.14-6.88,58.24,58.24,0,0,1,.33-7,15.9,15.9,0,0,1,.4-2.85,16.91,16.91,0,0,1,0,2.88c-.09,1.77-.23,4.22-.19,6.92a22.37,22.37,0,0,0,1,6.77,7.73,7.73,0,0,0,.95,1.81C232.73,248.12,232.9,248.35,232.87,248.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.89,227.72a5.82,5.82,0,0,1,.2,2.42,11.2,11.2,0,0,1-6.39,9.38,5.91,5.91,0,0,1-2.33.7c0-.08.87-.32,2.17-1a11.84,11.84,0,0,0,6.2-9.09C222.91,228.65,222.8,227.72,222.89,227.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.39,278.18s0,.09,0,.26,0,.46-.06.77q-.12,1.08-.3,3c-.29,2.61-.69,6.32-1.19,10.88-1,9.23-2.48,21.9-4.06,35.91a65.37,65.37,0,0,0,1.31,19.7A68,68,0,0,0,262.5,357c.9,2.56,1.73,4.95,2.5,7.14,1.51,4.34,2.73,7.87,3.59,10.35.4,1.2.72,2.14,1,2.82l.24.74a.8.8,0,0,1,.06.25s0-.07-.11-.24-.17-.42-.28-.72c-.26-.67-.6-1.6-1-2.79l-3.74-10.29c-.78-2.18-1.64-4.57-2.56-7.12a67.56,67.56,0,0,1-2.47-8.35,64.94,64.94,0,0,1-1.37-19.84c1.56-14.05,3.12-26.71,4.21-35.9.57-4.56,1-8.27,1.35-10.87.16-1.26.29-2.24.39-3,0-.31.08-.56.11-.76A.85.85,0,0,1,264.39,278.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "219.43 226.25 223.53 215.78 232.88 229.72 220.41 226.61",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.25,194.78l-11.09-24.87c-1.33-4-3.82-4.62-5.9-6.94L272.47,147.3c-20.26-8.3-31.29,19.52-31.29,19.52l-18.41,42c-21.65,7.17-6.32,23.8-6.32,23.8s-5.89-10.24-.09-13.93c6.06-3.87,12.78,6.32,19.24,16,7.63,11.42,32.41,18.84,32.41,18.84,2.9-3.06,2.09-13.75,4.36-19.49.72-1.81,17.88-41.56,17.88-41.56l6.65,16.11s8.52-10,12.66-11.58A47.13,47.13,0,0,1,317.25,194.78Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,212.46a4.15,4.15,0,0,1-.84.59,16.25,16.25,0,0,1-2.53,1.19,18.09,18.09,0,0,1-17.56-2.71,15.57,15.57,0,0,1-2.05-1.9,3.26,3.26,0,0,1-.62-.81c.07-.07,1,1.06,2.88,2.43a18.79,18.79,0,0,0,17.23,2.66C266.73,213.17,268,212.38,268,212.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,173h0l17.15,1.62,27.44-29-16.14-.56-28.73,2.84A74.54,74.54,0,0,1,222,173Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.77,157.74a1.81,1.81,0,0,1-.21.53l-.69,1.48c-.62,1.34-1.49,3.19-2.54,5.43-2.13,4.6-5,11-8,18.1s-5.86,13.53-8,18.14c-1.05,2.31-1.92,4.16-2.54,5.44l-.73,1.46a2.44,2.44,0,0,1-.29.5,3.31,3.31,0,0,1,.2-.54l.64-1.5,2.4-5.5c2-4.71,4.79-11.12,7.83-18.2s6-13.48,8.17-18.05c1.11-2.28,2-4.11,2.69-5.37.32-.58.57-1.06.77-1.44A2.65,2.65,0,0,1,245.77,157.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.12,166.17c.05.09-1,.64-2.47,1.88a17.74,17.74,0,0,0-2.31,2.39,19.58,19.58,0,0,0-2.18,3.45,20.39,20.39,0,0,0-1.36,3.84,17.47,17.47,0,0,0-.44,3.31c-.07,1.9.15,3.08.05,3.09a2.9,2.9,0,0,1-.2-.81,5.9,5.9,0,0,1-.14-1A10.4,10.4,0,0,1,289,181a15.68,15.68,0,0,1,.35-3.4,19,19,0,0,1,1.35-4,19.21,19.21,0,0,1,2.27-3.52,16.18,16.18,0,0,1,2.45-2.37,9.43,9.43,0,0,1,1.07-.76,6.12,6.12,0,0,1,.85-.51A2.62,2.62,0,0,1,298.12,166.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.91,126.34l-16.09,30.08a10.62,10.62,0,0,1-13.69,4.68h0a10.61,10.61,0,0,1-5-14.64l2.77-5.22s-7-4.53-3.72-12.09c2.92-6.74,13.64-25.78,15.91-29.8l13.56,6.07A15.23,15.23,0,0,1,302.91,126.34Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.9,141.13a19.19,19.19,0,0,0,11.05,1.6s-4.74,4.37-11.94.34Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.07,117.08a1.18,1.18,0,0,0,.55,1.55,1.13,1.13,0,0,0,1.54-.47,1.18,1.18,0,0,0-.55-1.55A1.13,1.13,0,0,0,276.07,117.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.13,116.13c.07.2,1.15,0,2.31.48s1.74,1.47,1.93,1.39.06-.35-.18-.78a3.28,3.28,0,0,0-1.47-1.29,3.14,3.14,0,0,0-1.92-.21C276.33,115.83,276.09,116,276.13,116.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.88,122.4a1.17,1.17,0,0,0,.55,1.55,1.13,1.13,0,0,0,1.54-.48,1.18,1.18,0,0,0-.55-1.54A1.12,1.12,0,0,0,286.88,122.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.39,121.42c.07.2,1.15,0,2.31.48s1.74,1.48,1.93,1.4.07-.35-.18-.79a3.27,3.27,0,0,0-1.47-1.28,3.07,3.07,0,0,0-1.92-.21C287.59,121.13,287.35,121.33,287.39,121.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.36,128.11a8.7,8.7,0,0,0-1.72-1.17c-.28-.17-.54-.35-.5-.57s.3-.51.59-.79l1.88-1.86a42.75,42.75,0,0,0,4.59-5,41.62,41.62,0,0,0-5,4.61l-1.85,1.89a1.87,1.87,0,0,0-.67,1.09.85.85,0,0,0,.29.65,2.31,2.31,0,0,0,.47.29A7.66,7.66,0,0,0,279.36,128.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.4,130.43c-.18-.09-.74,1.16-2.21,1.57s-2.75-.32-2.84-.15.19.37.75.64a3.39,3.39,0,0,0,2.33.2,2.94,2.94,0,0,0,1.78-1.35C282.49,130.84,282.49,130.47,282.4,130.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.12,116.76c0,.37,1.19.73,2.47,1.5s2.22,1.63,2.52,1.43c.14-.1.08-.48-.22-1a5.08,5.08,0,0,0-3.81-2.23C289.5,116.46,289.13,116.59,289.12,116.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.05,113c.09.36,1,.44,2,.85s1.69,1,2,.78.14-.42-.11-.82a2.87,2.87,0,0,0-1.39-1.14,2.93,2.93,0,0,0-1.8-.17C278.25,112.58,278,112.8,278.05,113Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.85,130.85c.16,0,5.85.78,3.39,5.85s-7,1.55-7,1.4S297.85,130.85,297.85,130.85Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.74,136.93s.06.1.17.25a1,1,0,0,0,.66.33,2.44,2.44,0,0,0,2-1.47,3.28,3.28,0,0,0,.37-1.38,1.14,1.14,0,0,0-.34-1,.5.5,0,0,0-.64,0c-.13.11-.15.22-.18.22s-.07-.14.07-.33a.64.64,0,0,1,.36-.22.75.75,0,0,1,.55.11,1.39,1.39,0,0,1,.54,1.23,3.35,3.35,0,0,1-.38,1.56,2.56,2.56,0,0,1-2.35,1.57,1.13,1.13,0,0,1-.75-.53C296.69,137.06,296.72,136.93,296.74,136.93Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.79,132a3,3,0,0,0-3,.17c-.66.58-1.11,1.38-1.77,2a2,2,0,0,1-2.42.38,1.73,1.73,0,0,1-.54-1.65,4.78,4.78,0,0,1,.73-1.67c1.37-2.26,2.94-4.42,4.12-6.79a13.49,13.49,0,0,0,1.61-7.67,7.4,7.4,0,0,0-4.5-6.07c-1.65-.58-3.49-.41-5.18-.89a6.91,6.91,0,0,1-4.44-4.08,12,12,0,0,0-.66-1.14c.06-.12.66-1.14,1.25-1.34,4.46-1.51,10.49.22,14.18,3.13a16.39,16.39,0,0,1,6.32,12.28c.05,4.7-2.91,9.88-5.66,13.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.84,131.45c1.41-2.4,3.69-4.13,5.43-6.29s3-5.21,1.7-7.69c-.42-.85-1.1-1.56-1.45-2.44a12.09,12.09,0,0,1-.5-2.81,9.76,9.76,0,0,0-4.84-7c-1.78-1-3.83-1.4-5.64-2.35-2.85-1.5-4.94-4.28-8-5.47a3.8,3.8,0,0,0-3.11-.1,1.88,1.88,0,0,0-.77,2.69,1.63,1.63,0,0,0-2.25-1.08,2.46,2.46,0,0,0-1.27,2.41,5.35,5.35,0,0,0,1.09,2.64,13.54,13.54,0,0,0,7.7,5.31l6.91-.54,5.66,4.19,4.18,6.67-7.59,9.86Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--light-bulb--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.65,92.1a24.38,24.38,0,1,0-33.27,24.25c.19,2.88.4,6.14.4,6.14l21.32-1.38s-.09-3.45-.25-6.53A24.36,24.36,0,0,0,257.65,92.1Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.38,121.51s0-.11,0-.3,0-.51,0-.89c0-.77.11-1.92.23-3.39s.29-3.28.62-5.35a36.91,36.91,0,0,1,1.77-6.92,23.64,23.64,0,0,1,1.77-3.77,4.53,4.53,0,0,1,1.57-1.6,2.51,2.51,0,0,1,2.31-.07,1.65,1.65,0,0,1,.83.91,1.67,1.67,0,0,1,0,1.26,3.49,3.49,0,0,1-1.77,1.74A6.7,6.7,0,0,1,237,99.26a5.12,5.12,0,0,1-.33-2.8,2.19,2.19,0,0,1,2.11-1.83,1.54,1.54,0,0,1,1.29.78,2.19,2.19,0,0,1,.29,1.48,4.78,4.78,0,0,1-1.55,2.53,7.24,7.24,0,0,1-5.57,2,6.34,6.34,0,0,1-4.93-3.2,3.69,3.69,0,0,1-.35-2.94,1.78,1.78,0,0,1,2.5-1.1,2.48,2.48,0,0,1,1.1,1,3.88,3.88,0,0,1,.46,1.38,6.93,6.93,0,0,1-.19,2.8,7.24,7.24,0,0,1-3.17,4.3,7.38,7.38,0,0,1-5,1,3.89,3.89,0,0,1-2.26-1,1.88,1.88,0,0,1-.29-2.33,1.61,1.61,0,0,1,1.06-.61,2.37,2.37,0,0,1,1.18.15,3.48,3.48,0,0,1,1.59,1.58c.7,1.28,1.27,2.53,1.85,3.72,2.26,4.78,3.9,8.73,5,11.47.55,1.37,1,2.44,1.24,3.16.13.36.23.64.31.83a2.19,2.19,0,0,1,.09.29l-.12-.28-.34-.81-1.29-3.15c-1.14-2.72-2.81-6.66-5.09-11.42-.58-1.18-1.17-2.45-1.86-3.7a3.29,3.29,0,0,0-1.48-1.47,1.68,1.68,0,0,0-1.95.38,1.65,1.65,0,0,0,.28,2,3.62,3.62,0,0,0,2.11.93,7.11,7.11,0,0,0,4.81-1,7,7,0,0,0,3-4.14,6.6,6.6,0,0,0,.18-2.69,2.63,2.63,0,0,0-1.39-2.15,1.52,1.52,0,0,0-1.27,0,1.55,1.55,0,0,0-.83,1,3.39,3.39,0,0,0,.33,2.7,6.07,6.07,0,0,0,4.7,3,6.93,6.93,0,0,0,5.33-1.93A4.51,4.51,0,0,0,240,96.85a1.93,1.93,0,0,0-.25-1.29,1.28,1.28,0,0,0-1.05-.64,1.77,1.77,0,0,0-1.19.47,2,2,0,0,0-.62,1.13,4.79,4.79,0,0,0,.31,2.64,6.43,6.43,0,0,0,8.4,3.73,3.24,3.24,0,0,0,1.64-1.6,1.44,1.44,0,0,0-.68-1.85,2.27,2.27,0,0,0-2.09.06A4.34,4.34,0,0,0,243,101a23.63,23.63,0,0,0-1.76,3.72,36.46,36.46,0,0,0-1.8,6.86c-.35,2.07-.54,3.87-.68,5.34s-.21,2.6-.28,3.39c0,.37-.06.67-.07.88S238.38,121.51,238.38,121.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.71,125.16l-18.3,1.19a1.39,1.39,0,0,1-1.47-1.29h0a1.38,1.38,0,0,1,1.29-1.46l18.31-1.18A1.37,1.37,0,0,1,246,123.7h0A1.38,1.38,0,0,1,244.71,125.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.79,126.36l-18.31,1.19a1.37,1.37,0,0,0,.18,2.74l2-.13,3,4.91a1.79,1.79,0,0,0,1.63.84l6.54-.42a1.81,1.81,0,0,0,1.51-1.06l2.26-5.23,1.37-.09a1.38,1.38,0,0,0-.18-2.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.69,79.18a17.72,17.72,0,0,1,4.67-3.55A13.17,13.17,0,0,1,225,74.29c.92-.15,1.45-.1,1.51.09.13.44-1.67,1.21-4,3a20.06,20.06,0,0,0-7.85,20.24c.53,2.95,1.34,4.73,1,5-.18.11-.6-.21-1.17-.94a12.65,12.65,0,0,1-1.82-3.47,17.84,17.84,0,0,1-1-5.76,19,19,0,0,1,1.25-7.15",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.45,75.06c-1.54.08-2.93-.25-3.14-1.06-.09-.4.17-.85.7-1.22a4.94,4.94,0,0,1,4.6-.28c.58.31.88.73.84,1.14",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M241,134.88a10.67,10.67,0,0,1-1.29-.31,10.66,10.66,0,0,0-3.13-.19,10.8,10.8,0,0,0-3,.77c-.74.32-1.18.58-1.2.54a3.71,3.71,0,0,1,1.11-.73,9,9,0,0,1,3.1-.87,8.84,8.84,0,0,1,3.21.28A3.87,3.87,0,0,1,241,134.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.65,129.26c0,.08-3.3.36-7.39.63s-7.39.41-7.4.32,3.3-.36,7.38-.62S243.64,129.18,243.65,129.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.64,131.51a11,11,0,0,1-1.79.29c-1.11.15-2.65.31-4.36.45s-3.25.21-4.37.24a10,10,0,0,1-1.81,0,10.08,10.08,0,0,1,1.8-.2l4.36-.33,4.36-.36A10.67,10.67,0,0,1,242.64,131.51Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Book--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.8,254l4,6.37s17-15.61,33.79-11.2C148.56,249.15,133.44,236.33,110.8,254Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.56,249.15s12.45-13.52,30.71-10.44l5,.75-1.58-2.87S150.9,225.71,148.56,249.15Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.28,203.56S97.34,199.27,81,208.12L107,257s21.26-20.49,41.6-7.87Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.28,203.56a1.72,1.72,0,0,1,.14.2l.37.62,1.44,2.43,5.4,9.26,19.12,33a.22.22,0,0,1-.3.3,27.47,27.47,0,0,0-9.57-3.67,30,30,0,0,0-5.39-.38,33.89,33.89,0,0,0-5.52.7,47.4,47.4,0,0,0-20.62,11l-.22.2a.24.24,0,0,1-.35,0l0-.05L80.81,208.22a.19.19,0,0,1,.08-.27h0A50.29,50.29,0,0,1,97.51,203a84.53,84.53,0,0,1,13.31-.58c3.68.13,6.55.42,8.49.66,1,.12,1.72.23,2.22.32l.57.1.18,0h-.19l-.57-.07c-.5-.06-1.24-.16-2.22-.26-2-.2-4.82-.45-8.49-.54a84.91,84.91,0,0,0-13.25.67,50.17,50.17,0,0,0-16.47,5l.08-.27,26,48.88-.39-.07.22-.2a52.65,52.65,0,0,1,9.94-7,41.5,41.5,0,0,1,10.92-4.14,32.72,32.72,0,0,1,5.61-.7,29.24,29.24,0,0,1,5.48.39,28.13,28.13,0,0,1,9.72,3.75l-.31.3-18.91-33-5.32-9.34-1.39-2.48c-.15-.28-.27-.49-.35-.65A1.68,1.68,0,0,1,122.28,203.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.48,193.53s-18.86-12-38.88,10l26.28,45.59s5.36-18.5,36.74-12.07Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.48,193.53a.88.88,0,0,1,.13.19c.08.15.2.34.34.59l1.33,2.32,5,8.84L185.81,237a.21.21,0,0,1-.08.29.21.21,0,0,1-.15,0h0l-4.67-.77a21.4,21.4,0,0,0-2.41-.27l-2.46-.2a21,21,0,0,0-2.51-.06L171,236c-.86,0-1.71.17-2.57.25a19.15,19.15,0,0,0-2.58.39l-2.57.58-2.53.89a26.77,26.77,0,0,0-2.44,1.13,7.63,7.63,0,0,0-1.18.67l-1.15.74c-.76.51-1.44,1.13-2.15,1.7a22.7,22.7,0,0,0-1.89,2,15.75,15.75,0,0,0-2.8,4.8h0a.25.25,0,0,1-.32.15.24.24,0,0,1-.13-.11l-1.06-1.83c-9.29-16.15-18-31.2-25.19-43.77a.23.23,0,0,1,0-.25,44.24,44.24,0,0,1,14.23-10.7,28.42,28.42,0,0,1,13.43-2.52,27.58,27.58,0,0,1,8.59,1.92,21.27,21.27,0,0,1,2.1,1l.52.3.16.12-.18-.09-.53-.27c-.47-.23-1.17-.57-2.11-.93a28.07,28.07,0,0,0-21.84.79,44.08,44.08,0,0,0-14.06,10.67l0-.24L148,247.19,149.1,249l-.46.06a16.46,16.46,0,0,1,2.89-5,27.13,27.13,0,0,1,1.94-2.07c.74-.59,1.43-1.23,2.21-1.74l1.17-.76a8,8,0,0,1,1.21-.68c.84-.39,1.63-.86,2.49-1.16l2.57-.89,2.62-.59a18,18,0,0,1,2.62-.39c.87-.08,1.73-.24,2.59-.25l2.57,0a17.75,17.75,0,0,1,2.53.06l2.48.21a19.42,19.42,0,0,1,2.43.27l4.7.79-.23.32c-7.17-13-13.16-23.89-17.38-31.56-2.09-3.81-3.74-6.83-4.87-8.91l-1.28-2.36c-.13-.26-.24-.46-.32-.61S161.48,193.53,161.48,193.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,184.62l28.13,54.15s22.85-1,32.53,10.14L122.6,203.56S107.32,184.62,88,184.62Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,184.62l.72,0,2.16.09c.24,0,.5,0,.76,0l.83.14,1.88.31a15.16,15.16,0,0,1,2.15.52,24.54,24.54,0,0,1,2.41.71c6.72,2.24,15.74,7.66,23.84,17l0,0h0l26.1,45.32a.25.25,0,0,1-.09.34.24.24,0,0,1-.3,0h0l-1.1-1.1a23.85,23.85,0,0,0-7.2-4.75,41,41,0,0,0-8.05-2.64,67.2,67.2,0,0,0-16-1.58h0a.24.24,0,0,1-.21-.12c-8.2-15.9-15.2-29.49-20.17-39.11C93.31,195,91.37,191.2,90,188.58c-.65-1.27-1.16-2.26-1.51-3l-.38-.75-.12-.25a1.41,1.41,0,0,1,.15.27l.42.77,1.58,3L96,199.84l20.3,38.82-.21-.12a67.19,67.19,0,0,1,16.11,1.56,42.08,42.08,0,0,1,8.14,2.66,24.39,24.39,0,0,1,7.34,4.86l1.14,1.12-.41.29c-9.67-16.85-18.62-32.47-26-45.36v0a65.6,65.6,0,0,0-12.31-11.14,47.43,47.43,0,0,0-11.28-5.88,24.71,24.71,0,0,0-2.4-.73,14.79,14.79,0,0,0-2.13-.54l-1.87-.34-.81-.15-.74-.06Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.8,338.2l.6,1a6.9,6.9,0,0,0,2.84,2.62l1,.52-1,.6a7,7,0,0,0-2.62,2.84l-.52,1.05-.6-1a6.9,6.9,0,0,0-2.84-2.62l-1.05-.52,1-.6a6.83,6.83,0,0,0,2.62-2.84Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.36,131.93l.6,1a6.88,6.88,0,0,0,2.84,2.61l1,.52-1,.61a6.78,6.78,0,0,0-2.62,2.84l-.52,1-.6-1a6.86,6.86,0,0,0-2.85-2.62l-1.05-.52,1-.6a7,7,0,0,0,2.62-2.85Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.94,167.52l.6,1a6.86,6.86,0,0,0,2.85,2.62l1.05.52-1,.6a6.9,6.9,0,0,0-2.61,2.85l-.52,1-.61-1a6.82,6.82,0,0,0-2.84-2.61L372.8,172l1-.61a6.78,6.78,0,0,0,2.62-2.84Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.64,351.15l.6,1a6.9,6.9,0,0,0,2.85,2.61l1.05.52-1,.61a6.91,6.91,0,0,0-2.62,2.84l-.51,1.05-.61-1a6.83,6.83,0,0,0-2.84-2.62l-1.05-.52,1-.6a6.86,6.86,0,0,0,2.62-2.85Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.41,389.74l.29.12a1.87,1.87,0,0,0,1,.1l.31-.06-.12.29a1.87,1.87,0,0,0-.1,1l.06.31-.29-.12a1.88,1.88,0,0,0-1-.1l-.31.06.12-.29a1.87,1.87,0,0,0,.1-1Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.86,128.81l.28.12a1.9,1.9,0,0,0,1,.1l.3-.06-.11.29a1.78,1.78,0,0,0-.1,1l.06.31-.29-.12a1.9,1.9,0,0,0-1-.1l-.3.06.11-.29a1.78,1.78,0,0,0,.1-1Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.63,105l.29.11a1.78,1.78,0,0,0,1,.1l.31,0-.12.28a1.9,1.9,0,0,0-.1,1l.06.3-.29-.11a1.78,1.78,0,0,0-1-.1l-.31,0,.12-.28a1.9,1.9,0,0,0,.1-1Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,308.16l.29.11a1.7,1.7,0,0,0,1,.1l.31-.05-.12.29a1.87,1.87,0,0,0-.1,1l.06.3-.29-.11a1.78,1.78,0,0,0-1-.1l-.31.06.12-.29a1.9,1.9,0,0,0,.1-1Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.91,386.69l-.28.29-.83.83L188.57,391l-12,11.57,0-.12C177.2,415,178,432,178.84,451l0,.42-.36-.23-4.33-2.9-27.44-18.37-.06,0,0-.06c-4.1-12.23-7.55-22.55-10-29.83-1.2-3.62-2.14-6.48-2.8-8.46l-.72-2.25q-.12-.36-.18-.57c0-.14-.06-.2-.05-.2l.08.18.21.57c.18.53.44,1.27.78,2.23l2.9,8.43c2.48,7.27,6,17.56,10.14,29.77l-.08-.1,27.47,18.34,4.33,2.89-.34.19c-.81-19-1.54-36-2.08-48.57v-.07l.05,0,12.08-11.46,3.29-3.09.86-.79C192.8,386.77,192.91,386.69,192.91,386.69Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.13 445.25 180.04 448.08 182.33 449.76 179.61 450.55 178.72 453.24 177.12 450.9 174.29 450.89 176.03 448.65 175.16 445.95 177.83 446.91 180.13 445.25",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.07 426.04 147.13 427.87 148.67 428.87 146.94 429.48 146.47 431.26 145.35 429.81 143.52 429.91 144.55 428.39 143.89 426.68 145.65 427.2 147.07 426.04",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.83 385.11 134.21 386.89 136.46 386.75 135.2 388.62 136.02 390.71 133.86 390.09 132.12 391.52 132.04 389.27 130.15 388.06 132.26 387.29 132.83 385.11",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.52 383.34 192.91 385.11 195.15 384.98 193.89 386.84 194.71 388.94 192.55 388.31 190.81 389.74 190.74 387.49 188.84 386.28 190.96 385.51 191.52 383.34",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.12 400.48 177 401.62 178.43 401.53 177.63 402.72 178.15 404.06 176.77 403.66 175.66 404.57 175.61 403.14 174.4 402.36 175.75 401.87 176.12 400.48",
    style: {
      fill: "#00CCAA"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Planets--inject-3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 123.19,
    cy: 304.91,
    r: 19.94,
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.6,311.13a3.26,3.26,0,1,1-3.25-3.25A3.26,3.26,0,0,1,120.6,311.13Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116,301.75a1.9,1.9,0,1,1-1.9-1.89A1.9,1.9,0,0,1,116,301.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.84,309.76c.09.35-17.07,16.81-12.64,20.32s23-5.49,38.89-18.3,30.35-28.37,26.38-32.49-23.79,8.07-23.79,8.07l2.37,1.52s12-7.69,15.78-4.71-7,14.64-22.27,25.78-30,18.94-32.27,15.89,8.5-13.22,8.5-13.22Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.84,309.76c.09.35-17.07,16.81-12.64,20.32s23-5.49,38.89-18.3,30.35-28.37,26.38-32.49-23.79,8.07-23.79,8.07l2.37,1.52s12-7.69,15.78-4.71-7,14.64-22.27,25.78-30,18.94-32.27,15.89,8.5-13.22,8.5-13.22Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.2,290.86c.16.19-1.19,1.34-2.72,3.64a18.35,18.35,0,0,0-.4,20.17c1.44,2.37,2.74,3.57,2.57,3.75s-1.7-.78-3.48-3.14a17.26,17.26,0,0,1-2.42-4.53A17.36,17.36,0,0,1,106,298.3a17.11,17.11,0,0,1,2.6-4.44C110.47,291.58,112.11,290.72,112.2,290.86Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 342.97,
    cy: 118.1,
    r: 16.45,
    transform: "translate(13.84 270.57) rotate(-43.86)",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M348.33,111.8a2.68,2.68,0,1,1,2.62,2.74A2.67,2.67,0,0,1,348.33,111.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M353.69,118.06a1.57,1.57,0,1,1,1.53,1.6A1.56,1.56,0,0,1,353.69,118.06Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M351.6,122.86a.56.56,0,0,1,.56.58.59.59,0,0,1-.59.57.58.58,0,0,1-.56-.59A.57.57,0,0,1,351.6,122.86Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreativityPana, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Creativity-pana.37158549.svg";
export { ForwardRef as ReactComponent };